/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../model/device';
import './pagination';
import '../model/shared/device_profile_type';
import '../model/shared/device';
import './status';
import '../model/device_profile';
import '../model/shared/device_profile';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "message": {
                    "nested": {
                      "FetchDeviceProfileV2Request": {
                        "fields": {
                          "merchantToken": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "device": {
                            "type": ".squareup.devicesettings.profiles.v2.model.Device",
                            "id": 2,
                            "rule": "optional"
                          },
                          "deviceProfileToken": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "pagination": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Pagination",
                            "id": 4,
                            "rule": "optional"
                          },
                          "deviceProfileType": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfileType",
                            "id": 5,
                            "rule": "optional"
                          },
                          "linkedDevice": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.Device",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      },
                      "FetchDeviceProfileV2Response": {
                        "fields": {
                          "status": {
                            "type": ".squareup.devicesettings.profiles.v2.message.Status",
                            "id": 1,
                            "rule": "optional"
                          },
                          "profiles": {
                            "type": ".squareup.devicesettings.profiles.v2.model.DeviceProfileV2",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "nextCursor": {
                            "type": "uint32",
                            "id": 3,
                            "rule": "optional"
                          },
                          "totalProfileCount": {
                            "type": "uint32",
                            "id": 4,
                            "rule": "optional"
                          },
                          "deviceProfiles": {
                            "type": ".squareup.devicesettings.profiles.v2.model.shared.DeviceProfile",
                            "id": 5,
                            "rule": "repeated"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.FetchDeviceProfileV2Request && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.message?.nested?.FetchDeviceProfileV2Response) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE FetchDeviceProfileV2Request @ squareup/devicesettings/profiles/v2/message/fetch_device_profile.proto at 17:1
 */
export const FetchDeviceProfileV2Request = $root.lookupType('squareup.devicesettings.profiles.v2.message.FetchDeviceProfileV2Request');
fixType(FetchDeviceProfileV2Request);
Builder.createAndAttachToType(FetchDeviceProfileV2Request);
/**
 * SOURCE FetchDeviceProfileV2Response @ squareup/devicesettings/profiles/v2/message/fetch_device_profile.proto at 26:1
 */
export const FetchDeviceProfileV2Response = $root.lookupType('squareup.devicesettings.profiles.v2.message.FetchDeviceProfileV2Response');
fixType(FetchDeviceProfileV2Response);
Builder.createAndAttachToType(FetchDeviceProfileV2Response);